import { Component, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { NestedGroupQuestion } from '../../../classes/question-nestedGroup';

@Component({
  selector: 'bepatient-field-nested-group',
  templateUrl: './field-nested-group.component.html',
  styleUrls: ['./field-nested-group.component.scss'],
  standalone: false
})
export class FieldNestedGroupComponent {
  @Input() question: NestedGroupQuestion;
  @Input() parent: UntypedFormGroup;

  get keys() {
    return this.parent.get(this.question.key) as UntypedFormArray;
  }
}
